import {
  getSupremaDisplayAlias,
  SUPREMA_PLATFORM,
} from "./simplifiedAccounts";
import { getCurrencyLabel } from "../../services/currency";

export default function PlatformAccountGrid({
  addSupremaAccount,
  canAddSupremaAccount,
  commitSupremaAlias,
  confirmDeposit,
  confirmWithdrawal,
  depositDrafts,
  editingSupremaAccountId,
  primarySupremaAccountId,
  selectedAccounts,
  setAccountBalance,
  setDeleteAccountTarget,
  setDepositDraft,
  setSupremaAlias,
  setWithdrawalDraft,
  startEditingSupremaAlias,
  supremaAlias,
  supremaAliasInputRef,
  withdrawalDrafts,
}) {
  if (!selectedAccounts.length) return null;

  return (
    <div className="platform-bankroll-grid">
      {selectedAccounts.map((account) => (
        <div key={account.id} className="simple-card platform-bankroll-card">
          <div className="platform-bankroll-card__header">
            {editingSupremaAccountId === account.id ? (
              <div
                className={
                  account.id === primarySupremaAccountId
                    ? "field-label field-label--primary-suprema-edit"
                    : "field-label"
                }
              >
                <input
                  ref={supremaAliasInputRef}
                  className="input-field suprema-alias-card-input"
                  type="text"
                  placeholder="Nome"
                  value={supremaAlias}
                  onChange={(event) => setSupremaAlias(event.target.value)}
                  onBlur={(event) =>
                    commitSupremaAlias(account.id, event.currentTarget.value)
                  }
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      commitSupremaAlias(account.id, event.currentTarget.value);
                    }
                    if (event.key === "Escape") {
                      commitSupremaAlias(account.id, account.alias);
                    }
                  }}
                />
              </div>
            ) : account.name === SUPREMA_PLATFORM ? (
              <div className="field-label">
                <div>{account.name}</div>
                <button
                  className="platform-account-alias"
                  type="button"
                  onClick={() => startEditingSupremaAlias(account)}
                >
                  {getSupremaDisplayAlias(account)}
                </button>
              </div>
            ) : (
              <label className="field-label" htmlFor={`platform-${account.id}`}>
                {account.name}
              </label>
            )}
            <div className="platform-account-actions">
              {account.id === primarySupremaAccountId && (
                <button
                  className="platform-account-add-button"
                  type="button"
                  onClick={addSupremaAccount}
                  disabled={!canAddSupremaAccount}
                >
                  + Conta
                </button>
              )}
              {account.name === SUPREMA_PLATFORM &&
                account.id !== primarySupremaAccountId && (
                  <button
                    className="btn-icon btn-del platform-account-remove"
                    type="button"
                    title="Remover banca"
                    onClick={() => setDeleteAccountTarget(account)}
                  >
                    X
                  </button>
                )}
            </div>
          </div>
          <input
            id={`platform-${account.id}`}
            className="input-field platform-bankroll-input"
            type="number"
            min="0"
            placeholder="Banca atual"
            value={account.balance}
            onChange={(event) => setAccountBalance(account.id, event.target.value)}
          />
          <div className="currency-field-note">
            {getCurrencyLabel(account.balanceCurrency)}
          </div>
          <div className="platform-withdrawal-control">
            <input
              id={`withdrawal-${account.id}`}
              className="input-field platform-withdrawal-input"
              type="number"
              min="0"
              placeholder="Saque"
              value={withdrawalDrafts[account.id] || ""}
              onChange={(event) =>
                setWithdrawalDraft(account.id, event.target.value)
              }
              onKeyDown={(event) => {
                if (event.key === "Enter") confirmWithdrawal(account.id);
              }}
            />
            <button
              className="btn-icon btn-edit platform-withdrawal-button"
              type="button"
              onClick={() => confirmWithdrawal(account.id)}
            >
              OK
            </button>
          </div>
          <div className="platform-withdrawal-control">
            <input
              id={`deposit-${account.id}`}
              className="input-field platform-withdrawal-input"
              type="number"
              min="0"
              placeholder="Deposito"
              value={depositDrafts[account.id] || ""}
              onChange={(event) => setDepositDraft(account.id, event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") confirmDeposit(account.id);
              }}
            />
            <button
              className="btn-icon btn-edit platform-withdrawal-button"
              type="button"
              onClick={() => confirmDeposit(account.id)}
            >
              OK
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
